// ANGULAR DEPENDANCY
import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PERMISSION_API_URL } from '../../../../constants/api/permission';
import { APIUtil } from '../../../../core/utils/api-util';
import { ApiPayload } from '../../../../models/common/api/api-payload.interface';
import { ApiResponse } from '../../../../models/common/api/api-response.interface';
import { ApiConfigService } from '../../../core/services/api-config/api-config.service';
import { BaseService } from '../../../core/services/base/base.service';
import { TokenStorageService } from '../../../core/services/token-storage/token-storage.service';

/**
 * This service is for Permission api calls
 * For handle Permission api calls
 *
 * @author Vikas Thakkar <vikas.thakkar@saeculumsolutions.com>
 *
 * Notes:-
 * Date: 27/04/2020 (Vikas Thakkar <vikas.thakkar@saeculumsolutions.com>) initially created Permission
 */
@Injectable()
export class PermissionService extends BaseService {

  constructor(
    protected httpClient: HttpClient,
    protected tokenStorage: TokenStorageService,
    public apiConfig: ApiConfigService) {
    super(httpClient, tokenStorage);
  }

  /**
  *  get all Master
  * @param payload : Api common payload object
  * @returns Observable<ApiResponse>
  */
  public getMobileVersionAll(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${PERMISSION_API_URL.GET_MOBILE_VERSION_ALL}`;
    return this.get(url);
  }

  /**
   *  get Master by pagging
   * @param payload : Api common payload object
   * @returns Observable<ApiResponse>
   */
  public getMobileVersionPagging(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${PERMISSION_API_URL.GET_MOBILE_VERSION_PAGING}`;
    return this.post(url, payload);
  }


  /**
  *  get Master by id
  * @param payload : Api common payload object
  * @returns Observable<ApiResponse>
  */
  public getMobileVersionById(payload: ApiPayload): Observable<ApiResponse> {
    const replaceParams = ['id'];
    // get url
    const url = APIUtil.getReplaceParams(`${this.apiConfig.getApiUrl()}${PERMISSION_API_URL.GET_MOBILE_VERSION}`, replaceParams, payload);
    return this.get(url);
  }

  /**
    *  add Master
    * @param payload : Api  payload object
    * @returns Observable<ApiResponse>
    */
  public addMobileVersion(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${PERMISSION_API_URL.MOBILE_VERSION}`;
    return this.post(url, payload);
  }

  /**
  *  update Master
  * @param payload : Api common payload object
  * @returns Observable<ApiResponse>
  */
  public updateMobileVersion(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${PERMISSION_API_URL.MOBILE_VERSION}`;
    return this.put(url, payload);
  }

  /**
  *  get Master
  * @param payload : Api common payload object
  * @returns Observable<ApiResponse>
  */
  public deleteMobileVersion(payload: ApiPayload): Observable<ApiResponse> {
    const replaceParams = ['id'];
    // get url
    const url = APIUtil.getReplaceParams(`${this.apiConfig.getApiUrl()}${PERMISSION_API_URL.GET_MOBILE_VERSION}`, replaceParams, payload);
    return this.delete(url);
  }


  /**
    *  get all Master Module Attribute
    * @param payload : Api common payload object
    * @returns Observable<ApiResponse>
    */
  public getMasterModuleAttributeAll(payload: any): Observable<ApiResponse> {
    const replaceParams = ['module_id'];
    let url = `${this.apiConfig.getApiUrl()}${PERMISSION_API_URL.GET_MASTER_ATTRIBUTE_MODULE_ALL}`;

    if (payload && payload.module_id) {
      url = APIUtil.getAppendParams(`${this.apiConfig.getApiUrl()}${PERMISSION_API_URL.GET_MASTER_ATTRIBUTE_MODULE_ALL}`, replaceParams, payload);
    }

    return this.get(url);
  }












  /**
   *  get Master Plan list by pagging (api/v1)
   * @param payload : Api common payload object
   * @returns Observable<ApiResponse>
   */
  public getMasterPlanPagging(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${PERMISSION_API_URL.GET_MASTER_PLAN_PAGING}`;
    return this.post(url, payload);
  }

  /**
   *  get all Master Plan (api/v1) - used for table export
   * @param payload : Api common payload object
   * @returns Observable<ApiResponse>
   */
  public getMasterPlanAll(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${PERMISSION_API_URL.GET_MASTER_PLAN_ALL}`;
    return this.get(url);
  }

  /**
   *  get Master Plan with its V2 feature flags by plan id (api/v2)
   * @param payload : Api common payload object
   * @returns Observable<ApiResponse>
   */
  public getMasterPlanFeature(payload: ApiPayload): Observable<ApiResponse> {
    const replaceParams = ['id'];
    const url = APIUtil.getReplaceParams(`${this.apiConfig.getApiUrlV2()}${PERMISSION_API_URL.GET_MASTER_PLAN_FEATURE}`, replaceParams, payload);
    return this.get(url);
  }

  /**
   *  add Master Plan with nested plan_feature (api/v2)
   * @param payload : Api payload object
   * @returns Observable<ApiResponse>
   */
  public addMasterPlanFeature(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrlV2()}${PERMISSION_API_URL.MASTER_PLAN_FEATURE}`;
    return this.post(url, payload);
  }

  /**
   *  add only the V2 feature row for an existing plan (api/v2)
   * @param payload : Api payload object
   * @returns Observable<ApiResponse>
   */
  public addOnlyMasterPlanFeature(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrlV2()}${PERMISSION_API_URL.ADD_ONLY_MASTER_PLAN_FEATURE}`;
    return this.post(url, payload);
  }

  /**
   *  update Master Plan (api/v2)
   *  Backend overwrites every plan column, so callers must send the FULL
   *  plan object. plan_feature null = leave the 34 feature flags untouched.
   * @param payload : Api common payload object
   * @returns Observable<ApiResponse>
   */
  public updateMasterPlanFeature(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrlV2()}${PERMISSION_API_URL.UPDATE_MASTER_PLAN_FEATURE}`;
    return this.put(url, payload);
  }

  /**
   *  archive Master Plan and its feature row (api/v2)
   * @param payload : Api common payload object
   * @returns Observable<ApiResponse>
   */
  public deleteMasterPlanFeature(payload: ApiPayload): Observable<ApiResponse> {
    const replaceParams = ['id'];
    const url = APIUtil.getReplaceParams(`${this.apiConfig.getApiUrlV2()}${PERMISSION_API_URL.DELETE_MASTER_PLAN_FEATURE}`, replaceParams, payload);
    return this.delete(url);
  }

  /**
    *  get all MasterRole Attribute
    * @param payload : Api common payload object
    * @returns Observable<ApiResponse>
    */
  public getMasterRoleAll(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${PERMISSION_API_URL.MASTER_ROLE}/all`;
    return this.get(url);
  }

  /**
   *  get MasterRole Attribute by pagging
   * @param payload : Api common payload object
   * @returns Observable<ApiResponse>
   */
  public getMasterRolePagging(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${PERMISSION_API_URL.MASTER_ROLE}/paging`;
    return this.post(url, payload);
  }


  /**
  *  get MasterRole Attribute by id
  * @param payload : Api common payload object
  * @returns Observable<ApiResponse>
  */
  public getMasterRole(payload: ApiPayload): Observable<ApiResponse> {
    const replaceParams = ['id'];
    // get url
    const url = APIUtil.getReplaceParams(`${this.apiConfig.getApiUrl()}${PERMISSION_API_URL.MASTER_ROLE}/{{id}}`, replaceParams, payload);
    return this.get(url);
  }

  /**
    *  add MasterRole Attribute
    * @param payload : Api  payload object
    * @returns Observable<ApiResponse>
    */
  public addMasterRole(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${PERMISSION_API_URL.MASTER_ROLE}`;
    return this.post(url, payload);
  }

  /**
  *  update MasterRole Attribute
  * @param payload : Api common payload object
  * @returns Observable<ApiResponse>
  */
  public updateMasterRole(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${PERMISSION_API_URL.MASTER_ROLE}`;
    return this.put(url, payload);
  }

  /**
  *  get MasterRole Attribute
  * @param payload : Api common payload object
  * @returns Observable<ApiResponse>
  */
  public deleteMasterRole(payload: ApiPayload): Observable<ApiResponse> {
    const replaceParams = ['id'];
    // get url
    const url = APIUtil.getReplaceParams(`${this.apiConfig.getApiUrl()}${PERMISSION_API_URL.MASTER_ROLE}/{{id}}`, replaceParams, payload);
    return this.delete(url);
  }

  /**
   *  add MasterRole Attribute
   * @param payload : Api  payload object
   * @returns Observable<ApiResponse>
   */
  public addMasterRoleRightBulk(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${PERMISSION_API_URL.MASTER_ROLE_RIGHT}/bulk`;
    return this.post(url, payload);
  }
}

